export default "__VITE_ASSET__DxLrmibC__"